<template>
  <div class="a-vs-c--single-statistic">
    <div class="host-statistic">
      <object :width="homePercentage" :class="resultHomeTeam"> </object>
    </div>
    <div :class="resultHomeTeamSecond">
      <div class="host-result">
        <span>{{ homeGoals }}</span>
      </div>
      <div>
        <span>:</span>
      </div>
      <div class="guest-result">
        <span>{{ guestGoals }}</span>
      </div>
    </div>
    <div class="guest-statistic">
      <object :width="awayPercentage" :class="resultGuestTeam"> </object>
    </div>
  </div>
</template>
<script>
export default {

  props: {
    homeGoals: {
      type: Number,
      default: 0
    },
    guestGoals: {
      type: Number,
      default: 0
    },
    homePercentage: {
      type: String,
      default: '0%'
    },
    awayPercentage: {
      type: String,
      default: '0%'
    }
  },
  computed: {
    resultHomeTeam: function () {
      if (this.homeGoals > this.guestGoals) {
        return 'a-vs-c-success-secondary'
      } else if (this.homeGoals === this.guestGoals) {
        return 'a-vs-c-neutral-secondary'
      } else {
        return 'a-vs-c-danger-secondary'
      }
    },
    resultGuestTeam: function () {
      if (this.homeGoals > this.guestGoals) {
        return 'a-vs-c-success-secondary'
      } else if (this.homeGoals === this.guestGoals) {
        return 'a-vs-c-neutral-secondary'
      } else {
        return 'a-vs-c-danger-secondary'
      }
    },
    resultHomeTeamSecond: function () {
      if (this.homeGoals > this.guestGoals) {
        return ' a-vs-c--statistic-result a-vs-d-success-secondary'
      } else if (this.homeGoals === this.guestGoals) {
        return ' a-vs-c--statistic-result a-vs-d-neutral-secondary'
      } else {
        return ' a-vs-c--statistic-result a-vs-d-danger-secondary'
      }
    }
  }
}

</script>
